import { Injectable } from '@angular/core';
import { HttpServices } from './http-service.service';
import { ETenderDTO, DefineTenderOfferDeadlineDTO } from '../models/e-tender.model';
import { AppConfig } from './app.config';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class EtenderService {
  constructor(private http: HttpServices) { }
  public AddEtenderForm(etenderForm: ETenderDTO) {
    return this.http.post('ETender/Add', etenderForm);
  }
  public EditEtenderForm(etenderForm: ETenderDTO) {
    return this.http.post('ETender/Edit', etenderForm);
  }
  public AddAdditionalSupplier(etenderForm: ETenderDTO) {
    return this.http.post('ETender/AddSupplier', etenderForm);
  }
  public GetCategories() {
    return this.http.get('Category/GetAll');
  }
  public GetCategoriesDataByIds(catIds: number[]) {
    return this.http.post('Category/GetByIds', catIds);
  }
  public GetTenderManagers() {
    return this.http.get('SPGroupUser/GetSPUsersByGroupName?groupName=SCAServices_ETenderManagers');
  }
  public GetETenderPaged(pageIndex: number, pageSize: number, dateFrom: string, dateTo: string, type: number,
                         category: number, tenderNumber: string, fileNumber: string, offerDeadlineFrom: string,
                         offerDeadlineTo: string, tenderMethod: number, currentUser: string, language: string) {
    return this.http.get('ETender/GetETenderPaged?pageIndex=' + pageIndex + '&pageSize=' + pageSize +
      '&language=' + language + '&creationDateFrom=' + dateFrom + '&creationDateTo=' + dateTo + '&type=' + type +
      '&category=' + category + '&tenderNumber=' + tenderNumber + '&fileNumber=' + fileNumber +
      '&offerDeadlineFrom=' + offerDeadlineFrom + '&offerDeadlineTo=' + offerDeadlineTo +
      '&tenderMethod=' + tenderMethod + '&currentUser=' + currentUser);
  }
  public CancelTender(etenderForm: ETenderDTO) {
    return this.http.post('ETender/Cancel', etenderForm);
  }
  public DeleteTender(eTenderId: string) {
    return this.http.get('ETender/Delete?eTenderId=' + eTenderId);
  }
  public GetTenderById(tenderRequestId: string) {
    return this.http.get('ETender/GetById?eTenderId=' + tenderRequestId);
  }
  public GetTenderRequestByFileNumber(fileNumber: string) {
    return this.http.get('ETender/GetTenderRequestByFileNumber?fileNumber=' + fileNumber);
  }
  public GetTenderViewAllFieldsById(tenderRequestId: string, language: string) {
    return this.http.get('ETender/GetTenderViewAllFieldsById?eTenderId=' + tenderRequestId + '&language=' + language);
  }
  public GetTenderViewAllFieldsAdminById(tenderRequestId: string, language: string) {
    return this.http.get('ETender/GetTenderViewAllFieldsAdminById?eTenderId=' + tenderRequestId + '&language=' + language);
  }
  public GetTenderOfferDeadlineById(tenderRequestId: string) {
    return this.http.get('ETender/GetTenderOfferDeadlineById?eTenderId=' + tenderRequestId);
  }
  public GetTenderViewById(tenderRequestId: string, language: string) {
    return this.http.get('ETender/GetTenderViewById?eTenderId=' + tenderRequestId + '&language=' + language);
  }
  public UpdateTenderOfferDeadline(DefineTenderOfferDeadlineForm: DefineTenderOfferDeadlineDTO) {
    return this.http.post('ETender/UpdateTenderOfferDeadline', DefineTenderOfferDeadlineForm);
  }

  public GetUserGroups(email: string) {
    return this.http.get('SPGroupUser/GetSPGroupByUserEmail?email=' + email);
  }

  public GetSupplierETenderPaged(pageIndex: number, pageSize: number, category: number,
                                 currentUser: string, language: string) {
    return this.http.get('ETender/GetSupplierETenderPaged?pageIndex=' + pageIndex + '&pageSize=' + pageSize +
      '&language=' + language + '&category=' + category + '&currentUser=' + currentUser);
  }
  public ExportETenderExcel(etenderObject: string, language: string, dateFrom: string, dateTo: string, type: number,
                            category: number, tenderNumber: string, fileNumber: string, offerDeadlineFrom: string,
                            offerDeadlineTo: string, tenderMethod: number, currentUser: string) {
    const httpOptions = {
      responseType: 'blob' as 'json'
    };
    return this.http.http.post(AppConfig.settings.apiServer.apiUrl + 'ETender/ExportETenderExcel?language='
      + language + '&from=' + dateFrom + '&to=' + dateTo + '&type=' + type + '&category=' + category +
      '&tenderNumber=' + tenderNumber + '&fileNumber=' + fileNumber + '&offerDeadlineFrom=' +
      offerDeadlineFrom + '&offerDeadlineTo=' + offerDeadlineTo + '&tenderMethod=' + tenderMethod +
      '&currentUser=' + currentUser, { Data: etenderObject }, httpOptions).subscribe(result => {
        this.downLoadFile(result, 'application/vnd.ms-excel');
      }, () => { }, () => {
      });
  }
  downLoadFile(data: any, type: string) {
    const blob = new Blob([data], { type });
    saveAs(blob, 'ExcelReport.xlsx');
  }
}
